import React from "react";
import Initial from "./pages/Initial";
import { We } from "./pages/We";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { Cripto } from "./pages/Cripto";
import { Token } from "./pages/Token";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Initial />} />
        <Route path="/we" element={<We />} />
        <Route path="/cripto" element={<Cripto />} />
        <Route path="/token" element={<Token />} />
      </Routes>
    </Router>
  );
}

export default App;
